import React from 'react';

import { Styles } from './styles/admission';
import HeaderTwo from '../../components/HeaderTwo';
import { BreadcrumbBox } from '../../components/common/Breadcrumb';
import FooterTwo from '../../components/FooterTwo';

const Admission = () => {
    return (
        <Styles>
            {/* Main Wrapper */}
            <div className="main-wrapper admission-process-page">

                {/* Header 2 */}
                <HeaderTwo />

                {/* Breadcrumb */}
                <BreadcrumbBox title="Admission Process" />

                {/* Admission Process Area */}
                <section className="admission-process-area">
                    <Styles>
                        <div className="admission-page">
                            <div className="process-area">
                                <div className="container">
                                    <div className="section-title">
                                        <h1>Online Admission Process</h1>
                                        <p>Follow the steps below to complete the admission process online.</p>
                                    </div>

                                    <div className="process-section">
                                        <div className="section-header">
                                            <h3>Step 1: Online Application</h3>
                                        </div>
                                        <div className="process-list">
                                            <ul>
                                                <li>
                                                    <div className="step-number">1</div>
                                                    <div className="step-content">Fill out the online application form completely.</div>
                                                </li>
                                                <li>
                                                    <div className="step-number">2</div>
                                                    <div className="step-content">Fill required details (birth certificate, previous school records).</div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>

                                    <div className="admission-note">
                                        <h4>Apply Now:</h4>
                                        <p>Click the link below to begin the online admission process:</p>
                                        <a href="https://nssemhs.dschoolapp.com/admission" target="_blank" rel="noopener noreferrer" className="apply-button">
                                            Apply Online
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Styles>
                </section>

                {/* Footer 2 */}
                <FooterTwo />

            </div>
        </Styles>
    );
};

export default Admission;
